module.exports = __webpack_public_path__ + "img/l6.2ad1ce7a.png";